export default "__VITE_ASSET__CaQJK_gO__"